import React from 'react';
import { FormControl, Input } from '@mui/material';

function FileUpload({
                      onChange,
                      onError = (msg => console.error(msg)),
                      allowedExtensions = [".txt"],
                      maxNumFiles = 1
                    }) {

  const uploadRef = React.useRef(null);

  function handleFileChange() {
    let fileList = uploadRef.current.files;
    let keys = Object.keys(fileList);
    let files = keys.map(k => {
      return {
        name: fileList[k].name,
        fileObj: fileList[k]
      }
    });

    if (files.length > maxNumFiles) {
      uploadRef.current.value = null; // Clear selected images
      onError("Exceeded maximum number of files to upload! (" + maxNumFiles + ")");
    }
    else {
      onChange(files);
    }
  }

  return (
    <div>
      <FormControl variant="outlined">
        <Input
          inputRef={uploadRef}
          type="file"
          onChange={handleFileChange}
          onClick={event => event.target.value = null}
          inputProps={{multiple: false, accept: allowedExtensions.join(',')}}
          sx={{
            padding: 1.4,
            border: "1px",
            borderStyle: "solid",
            borderColor: "#c5c5c5",
            borderRadius: 1,
            '&:hover': {
              border: "1px",
              borderStyle: "solid",
              borderColor: "#000000"
            },
            '&:focus': {
              border: "1px",
              borderStyle: "solid",
              borderColor: "#000000"
            }
          }}
        />
      </FormControl>
    </div>
  );
}

export default FileUpload;
